module.exports = __webpack_public_path__ + "static/hero-alec-btb-8369430fbfa9a77e7b4949ffdaa2f9fb.png";